import { ICaseModel } from '../../../interfaces/ICase';
import { useMutation } from 'react-query';
import { useZoneContext } from '../../../contexts/useZoneContext';

export const useSaveCaseEasyUpdateMutation = () => {
    const zoneContext = useZoneContext();

    return useMutation({
        mutationFn: async (caseModel: ICaseModel) => {
            const response = await zoneContext.zoneApiClient.easyUpdateCase(caseModel);

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                const { errors } = response;
                const firstError = errors.at(0);

                if (firstError?.message) {
                    throw new Error(`Failed to update Case: ${firstError?.message}`);
                } else if(response.errorMessage) {
                    throw new Error(`${response.errorMessage}`);
                }

                throw new Error('Failed to update case');
            }

            return response.payload;
        },
    });
};
